import React, { FC, useState } from "react";
import { LegacyLocalization } from "../../models/types";
import { Button, Card, Collapse, Container, Row } from "react-bootstrap";
import { LegacyLocalizationItem } from "../variationItems/LegacyLocalizationItem";
import {
    VariationCollapseState,
    VariationViewItemProps,
    VariationViewType
} from "../../models/common";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronDown,
    faChevronUp,
    faPlus
} from "@fortawesome/free-solid-svg-icons";
import { useLocalState } from "../../graphql/hooks";
import {
    getVariationCollapseState,
    saveVariationCollapseState
} from "../../common/Helpers";

interface Props extends VariationViewItemProps {
    openNewItemModal: (type: VariationViewType) => void;
}

export const LegacyLocalizations: FC<Props> = ({
    revision,
    openNewItemModal
}) => {
    const state = useLocalState();
    const version = revision?.buildData?.version || -1;
    const [showLegacyLocalizations, setShowLegacyLocalizations] = useState(
        getVariationCollapseState(VariationCollapseState.LegacyLocalizations)
    );

    const updateShowLegacyLocalizations = (newState: boolean) => {
        saveVariationCollapseState(
            VariationCollapseState.LegacyLocalizations,
            newState
        );
        setShowLegacyLocalizations(newState);
    };

    const items = revision?.buildData?.legacyLocalizations?.map(
        (object: LegacyLocalization) => (
            <LegacyLocalizationItem
                key={object.id}
                version={version}
                defaultValue={object}
                revision={revision}
            />
        )
    );
    const hasLocalizations =
        revision &&
        revision.buildData &&
        revision.buildData.legacyLocalizations &&
        revision.buildData.legacyLocalizations.length > 0;

    return (
        <>
            <Container className="mb-4 p-0">
                <Card>
                    <Card.Header className="d-flex align-items-center">
                        <h5 className="text-inverse-50 mb-1 me-2">
                            Legacy Localizations
                        </h5>
                        {hasLocalizations && (
                            <div
                                className="mb-1 ms-1 text-inverse-50 mouseHover"
                                onClick={() => {
                                    updateShowLegacyLocalizations(
                                        !showLegacyLocalizations
                                    );
                                }}
                                data-toggle="tooltip"
                                title="Toggle Localizations visibility"
                            >
                                <FontAwesomeIcon
                                    icon={
                                        showLegacyLocalizations
                                            ? faChevronUp
                                            : faChevronDown
                                    }
                                />
                            </div>
                        )}
                        <div className="d-flex float-end ms-auto">
                            <Button
                                onClick={() =>
                                    openNewItemModal(
                                        VariationViewType.LegacyLocalizations
                                    )
                                }
                                className="text-primary btn-sm ms-2 mouseHover"
                                data-toggle="tooltip"
                                title="Add new Legacy localization"
                            >
                                <FontAwesomeIcon
                                    className="text-white"
                                    icon={faPlus}
                                    size="lg"
                                />
                            </Button>
                        </div>
                    </Card.Header>
                    <Collapse in={showLegacyLocalizations}>
                        <div>
                            <Card.Body className="p-2">
                                <div>
                                    <Row className="d-flex m-auto justify-content-start">
                                        {items}
                                    </Row>
                                </div>
                            </Card.Body>
                        </div>
                    </Collapse>
                </Card>
            </Container>
        </>
    );
};
